import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { IVAArea } from "./Styles";

export default function IVA({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="IVA"
            value={!value ? document.amount.iva.text : value}
          />
        </div>
      ) : (
        <IVAArea>
          <Informative
            readonly={true}
            label="IVA"
            value={!value ? document.amount.iva.text : value}
          />
        </IVAArea>
      )}
    </>
  );
}
